import React from "react";

import { IgChip, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";

export const BalanceExceededBadge = () => {
  const theme = useTheme();
  return <IgChip label={"Balance Exceeded"} size={"small"} />;
};
